import { sanitizePortalHTMLContent } from "@tellescope/utils";
import type { HtmlBlock as HtmlBlockType } from "../../../shared/schema";

interface HtmlBlockProps {
  content: HtmlBlockType["props"]["content"];
}

export const HtmlBlock: React.FC<HtmlBlockProps> = ({ content }) => {
  if (!content) return null;

  return <div dangerouslySetInnerHTML={{ __html: sanitizePortalHTMLContent(content) }} />;
};
